import React, { useState, useEffect } from 'react';

import './IconsBar.scss';

import { getString } from '../../helpers/styles';
import Heart from '../../shared/assets/icons/heart.svg';
import Whatsapp from '../../shared/assets/icons/whatsapp.svg';
import Twitter from '../../shared/assets/icons/twitter.svg';
import Facebook from '../../shared/assets/icons/facebook.svg';

export default function IconsBar(props) {
  const { contentUri, user, bookmarks, shareUrls, showLoginPopup } = props;

  const { facebook, twitter, whatsapp } = shareUrls || {};

  const savedBookmark =
    bookmarks &&
    bookmarks.find((item) => item.content && item.content.uri === contentUri);

  const [whatsappIcon, showWhatsappIcon] = useState(false);

  useEffect(() => {
    if (document.body.offsetWidth <= 850) showWhatsappIcon(true);
  }, []);

  return (
    <section id="icons" className={getString('icons_bottom', props.bottom)}>
      <ul>
        {whatsappIcon && (
          <li className="icons_whatsapp">
            <a href={whatsapp}>
              <Whatsapp />
            </a>
          </li>
        )}

        <li>
          <a href={facebook} target="_blank" rel="noopener noreferrer">
            <Facebook />
          </a>
        </li>

        <li>
          <a href={twitter} target="_blank" rel="noopener noreferrer">
            <Twitter />
          </a>
        </li>

        <li className="icons_bookmark" onClick={() => bookmark()}>
          <span className={getString('icons_saved_bookmark', savedBookmark)}>
            <Heart />
          </span>
        </li>
      </ul>
    </section>
  );

  function bookmark() {
    const { username } = user;

    if (!username) return showLoginPopup('Log in om dit artikel op te slaan');

    if (savedBookmark)
      props.removeBookmark({ variables: { id: savedBookmark.id } });
    else props.addBookmark({ variables: { contentUri } });
  }
}
